const defaultCtx = {
    fetcher: typeof window !== 'undefined' && window.fetch,
    protocol: 'https',
    transform: (x) => x,
    parse: (x) => x.json(),
    toRaw: (x) => x,
    method: 'GET',
    headers: {
        'content-type': 'application/json',
        accept: 'application/json'
    },
    hosts: {
        api: 'api-preprod.weenat.com/api',
        tiles: 'api-preprod.weenat.com/api',
        dss: 'api-preprod.weenat.com/api',
        ts: 'api-preprod.weenat.com/api'
    },
    bodySerializer: JSON.stringify
};
export default defaultCtx;
